// src/pages/CalendarPage.tsx
import React from 'react';
import { Box } from '@mui/material';
import MonthCalendar from '../components/calendar/MonthCalendar';
import VisuallyHiddenHeading from '../components/common/VisuallyHiddenHeading';

// Header height is 64px — the calendar fills the remaining viewport height.
const HEADER_HEIGHT = 64;

const CalendarPage: React.FC = () => {
  return (
    <Box
      sx={{
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <VisuallyHiddenHeading title="Calendar" />
      <MonthCalendar />
    </Box>
  );
};

export default CalendarPage;
